import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.4rem;

  &.show {
    border-bottom: 0.01rem solid var(--gray_light_light);
    padding-bottom: 1rem;
  }

  .categories-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  .father-categories-list {
    width: 100%;

    .father-category,
    .children-category {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      text-transform: none;
      padding: 0.4rem 0.8rem;
      color: var(--white);
      min-width: 11rem;
      gap: 1.2rem;
      width: 100%;
      user-select: none;
    }

    .father-category.brands {
      cursor: pointer;
    }

    .fake-icon {
      width: 0.58rem;
      height: 0.81rem;
    }

    .icon {
      margin-left: 0.4rem;
      cursor: pointer;
    }

    .children-categories-list,
    .children-childrens-list {
      margin-left: 0.8rem;
    }

    .children-categories-list .children-category {
      padding: 0.4rem 0.8rem;
      gap: 1.2rem;
    }

    .children-childrens-list {
      border-radius: 0 0 0.8rem 0;
    }
  }
`;
